import { useCompanyRankings } from './use-company-rating.query';

export const useCompanyRankingLoadingStates = (_companyId: string | null) => {
  const { data: ratings, isLoading } = useCompanyRankings();

  // Only treat the initial load as loading. Mutation/refetch loading caused a
  // blink by swapping the header and averages for a Loader on every edit.
  return { ratings, isLoading: isLoading && !ratings };
};
